import { useTranslate } from "common/utilities/useTranslate";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { SourcesFilter } from "domains/search/components/SourcesFilter/SourcesFilter";

export const KnowledgeSearchFilterModal = () => {
  const translate = useTranslate();

  return (
    <>
      <ModalHeader title={translate("app.filter.title")} />
      <SourcesFilter />
    </>
  );
};
